<template>
  <table-view
    ref="tableList"
    :searchModel="searchModel"
    :tableModel="tableModel"
    :tableData="tableData"
    @searchChange="handleSearchChange"
    :pages="pages"
    tableCardTitle="BUREAU REPORT"
    :RightBtnOptions="{ text: 'Add', isHavePermission: true }"
    @pageChange="params => _getTableData(params)"
    @changeTitleActionBtn="handleAddBtn"
  >
    <template v-slot:action="{ tableRow }">
      <template
        v-if="
          tableRow.row.bureauNameInt === 4 && tableRow.row.productNameInt === 3
        "
      >
        <a href="/creditSummary.pdf" style="color: #3a3f63" download>
          <i class="el-icon-download" style="font-size: 20px"></i>
        </a>
      </template>
      <template v-else>
        <a
          href="javascript:void(0)"
          class="icon-view1"
          style="margin-right: 20px; color: #3a3f63; font-size: 20px"
          @click="handleView(tableRow.row)"
        />
      </template>
    </template>
  </table-view>
</template>

<script>
import { getTableData } from './api'
const BRAZIL_VALUES = [3, 4]
const BRADSTREET_GLOBAL_VALUES = [1, 2]
const CREDIT_RISK_MONITOR_VALUES = [5, 6, 7, 8, 9]
const bureauSearch = [
  {
    name: 'D&B Brazil',
    id: 1,
  },
  {
    name: 'Dun & Bradstreet Global',
    id: 2,
  },
  {
    name: 'Credit Risk Monitor',
    id: 3,
  },
  {
    name: 'Linkredit Report',
    id: 4,
  },
]

export default {
  data() {
    const searchModel = [
      {
        label: 'Bureau Name',
        type: 'select',
        key: 'bureauName',
        layout: {
          md: 24,
          lg: 10,
        },
        selectList: bureauSearch,
        change: this.ProductNameList,
      },
      {
        label: 'Product Name',
        type: 'select',
        key: 'productName',
        layout: {
          md: 24,
          lg: 10,
        },
        selectList: [],
      },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        layout: {
          md: 24,
          lg: 10,
        },
        selectList: [
          { id: 1, name: 'Success' },
          { id: 2, name: 'Fail' },
          { id: 3, name: 'In Progress' },
        ],
      },
    ]
    const tableModel = [
      {
        width: 80,
        label: 'Action',
        slotName: 'action',
      },
      {
        width: 200,
        label: 'Event',
        prop: 'id',
      },
      {
        width: 200,
        label: 'Bureau Name',
        prop: 'bureauName',
      },
      {
        width: 120,
        label: 'Product Name',
        prop: 'productName',
      },
      {
        width: 120,
        label: 'Status',
        prop: 'statusStr',
      },
      {
        width: 130,
        label: 'Submission Date',
        prop: 'createTime',
      },
      {
        width: 130,
        label: 'Completion Date',
        prop: 'updateTime',
      },
      // {
      //   width: 130,
      //   label: 'Foundation Date',
      //   prop: 'updateTime',
      // },
      {
        minWidth: 240,
        label: 'Message',
        prop: 'message',
      },
    ]
    return {
      disposeProductNameList: [
        {
          name: 'Lookup',
          id: 1,
        },
        {
          name: 'Global Data Packet/Report',
          id: 2,
        },
        {
          name: 'CKR Lookup',
          id: 3,
        },
        {
          name: 'CKR Report',
          id: 4,
        },
        {
          name: 'Company Search by Name',
          id: 5,
        },
        {
          name: 'Company Search by Ticker',
          id: 8,
        },
        {
          name: 'Company Search by Phone',
          id: 9,
        },
        {
          name: 'Company Financial Report',
          id: 7,
        },
      ],
      tableModel,
      searchModel,
      tableData: [],
      pages: {},
      scoreNameList: [],
    }
  },
  mounted() {
    this.companyId = this.$route.params.customerId
    this.initTable()
  },
  methods: {
    handleDownload() {},
    ProductNameList(name) {
      this.searchModel[0].defaultValue = name
      let arr = null
      switch (name) {
        case 1:
          arr = this.disposeProductNameList.filter(item =>
            BRAZIL_VALUES.includes(item.id),
          )
          break
        case 2:
          arr = this.disposeProductNameList.filter(item =>
            BRADSTREET_GLOBAL_VALUES.includes(item.id),
          )
          break
        case 3:
          arr = this.disposeProductNameList.filter(item =>
            CREDIT_RISK_MONITOR_VALUES.includes(item.id),
          )
          break
        case 4:
          arr = [
            {
              name: 'Financial Summary',
              id: 10,
            },
            {
              name: 'Commercial Information Summary',
              id: 11,
            },
            {
              name: 'Credit Evaluation Analysis Summary',
              id: 12,
            },
          ]
          break
      }
      this.searchModel[1].selectList = arr
    },
    handleAddBtn() {
      this.$router.push({
        name: 'bureau-report-add',
        params: { customerId: this.$route.params.customerId },
      })
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        // 模拟假数据
        let data, page
        if (params.bureauName === 4) {
          const dataObj = {
            10: {
              code: '000000',
              msg: 'success',
              data: [
                {
                  id: '1539863213314772993',
                  statusStr: 'SUCCESS',
                  message: 'success',
                  bureauName: 'Linkredit Report',
                  productName: 'Financial Summary',
                  createTime: '2022-06-23 14:49:34',
                  updateTime: '2022-06-23 14:49:40',
                  dnbReportProductName: null,
                  bureauNameInt: 4,
                  productNameInt: 1,
                },
              ],
              page: {
                current: 1,
                size: 10,
                total: 1,
              },
            },
            11: {
              code: '000000',
              msg: 'success',
              data: [
                {
                  id: '1539863213314772994',
                  statusStr: 'SUCCESS',
                  message: 'success',
                  bureauName: 'Linkredit Report',
                  productName: 'Commercial Information Summary',
                  createTime: '2022-06-24 14:49:34',
                  updateTime: '2022-06-24 14:49:40',
                  dnbReportProductName: null,
                  bureauNameInt: 4,
                  productNameInt: 2,
                },
              ],
              page: {
                current: 1,
                size: 10,
                total: 1,
              },
            },
            12: {
              code: '000000',
              msg: 'success',
              data: [
                {
                  id: '1539863213314772995',
                  statusStr: 'SUCCESS',
                  message: 'success',
                  bureauName: 'Linkredit Report',
                  productName: 'Credit Evaluation Analysis Summary',
                  createTime: '2022-06-25 14:49:34',
                  updateTime: '2022-06-25 14:49:40',
                  dnbReportProductName: null,
                  bureauNameInt: 4,
                  productNameInt: 3,
                },
              ],
              page: {
                current: 1,
                size: 10,
                total: 1,
              },
            },
          }
          const result = dataObj[params.productName]
          data = result.data
          page = result.page
        } else {
          bureauSearch.forEach(item => {
            if (item.id === params.bureauName) {
              params.bureauName = item.name
            }
            return params.bureauName
          })
          this.disposeProductNameList.forEach(item => {
            if (item.id === params.productName) {
              params.productName = item.name
            }
            return params.productName
          })
          const result = await getTableData({
            ...params,
            companyId: this.companyId,
          })
          data = result.data
          page = result.page
        }

        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleView(row) {
      const { productNameInt, bureauNameInt, dnbReportProductName } = row
      // 模拟假数据
      if (bureauNameInt === 4) {
        this.$router.push({
          name: 'bureau-report-mock-detail',
          query: {
            productNum: productNameInt,
          },
        })
        return
      }
      const query = {}
      query.productName = productNameInt
      if (dnbReportProductName) {
        query.globalReportType = dnbReportProductName
      }
      this.$router.push({
        name: 'bureau-report-detail',
        query,
      })
      this.$store.commit('setBureauReportBasicInfo', row)
    },
  },
}
</script>
